import axios from 'axios';

const namespaced = true

const state = {
    posts: [],
    fetchActive: true
}

function parsePublishAt(value) {
    if (!value) return null;
    if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
    let raw = String(value).trim();
    if (!raw) return null;
    raw = raw.replace(' ', 'T');
    if (/[+-]\d{2}$/.test(raw)) raw += ':00';
    else if (!/[zZ]$|[+-]\d{2}:\d{2}$/.test(raw)) raw += 'Z';
    const date = new Date(raw);
    return isNaN(date.getTime()) ? null : date;
}

function collectVisiblePosts(posts, newstags, time) {
    const visible = [];
    const tags = Array.isArray(newstags) ? newstags : [];
    const list = Array.isArray(posts) ? posts : [];
    for (let i = 0; i < list.length; i++) {
        const post = list[i];
        if (post.tag) {
            post.newstags = String(post.tag).split(',').map((tagId) => tags.find((nt) => nt.id == tagId));
        }
        const publishAt = parsePublishAt(post.publish_at);
        if (!publishAt || publishAt >= new Date()) continue;
        post.publish_at = publishAt;
        post.unread = publishAt > time;
        if (!visible.some((item) => item.id === post.id)) {
            visible.push(post);
        }
    }
    return visible;
}

const actions = {
    async getAll({dispatch}) {
        return await dispatch('database/getItems', {table: 'news'}, {root: true})
    },
    async fetchFromHttp({dispatch}, id) {
        let posts = (await axios.get('https://mantel-api.mobile.documedias.systems/v2/conferences/' + id + '/news')).data;
        await dispatch('database/upsertItems', {items: posts, table: 'news'}, {root: true});
        return posts;
    },

    async fetchNewsTags({dispatch}) {
        return await dispatch('database/getItems', {table: 'news_tags'}, {root: true})
    },

    async fetchNews({dispatch, state, rootState}, id) {
        try {
            const newstags = await dispatch('fetchNewsTags');
            let posts;
            try {
                posts = await dispatch('fetchFromHttp', id);
            } catch (err) {
                console.log('EERRORR', err);
                posts = await dispatch('getAll');
            }
            const sorted = (Array.isArray(posts) ? posts : []).sort((a, b) => {
                return (parsePublishAt(b.publish_at)?.getTime() || 0) - (parsePublishAt(a.publish_at)?.getTime() || 0);
            });
            const oldTime = await dispatch('personalDB/getItem', 'timeStamps_' + rootState.currentConference.currentConference, {root: true});
            const time = await dispatch('personalDB/setTime', {
                name: 'timeStamps_' + rootState.currentConference.currentConference,
                item: oldTime
            }, {root: true});
            state.posts = collectVisiblePosts(sorted, newstags, time);
        } catch (err) {
            console.log('EERRORR', err);
        } finally {
            state.fetchActive = false;
        }
    },

    getNewsNumber() {
        return state.newsNumber;
    }
}
const mutations = {
    addNewsNumber(state, newsNumber) {
        state.newsNumber = newsNumber + state.newsNumber;
    },
    resetNewsNumber(state, newsNumber) {
        state.newsNumber = newsNumber;
    }
}
const getters = {}

export const news = {
    namespaced,
    state,
    getters,
    mutations,
    actions
}
